import script from "./CotacoesMoedaConsulta.vue?vue&type=script&setup=true&lang=js"
export * from "./CotacoesMoedaConsulta.vue?vue&type=script&setup=true&lang=js"

import "./CotacoesMoedaConsulta.vue?vue&type=style&index=0&id=58650892&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58650892"]])

export default __exports__